import { render, staticRenderFns } from "./TaskCreate.vue?vue&type=template&id=c0ac659c"
import script from "./TaskCreate.vue?vue&type=script&lang=js"
export * from "./TaskCreate.vue?vue&type=script&lang=js"
import style0 from "./TaskCreate.vue?vue&type=style&index=0&id=c0ac659c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports